import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import { productsByCategory } from 'config/products';
import { ProductCard } from 'components/ProductCard.tsx/ProductCard';
import styles from '../SelectImageStep.scss';

export const SelectImageStepPreview: FC = () => {
  const selectedCategory = useAppStore((state) => state.selectedCategory);
  const selectedProducts = useAppStore((state) => state.selectedProducts);

  const products = selectedProducts
    .map((productId) => productsByCategory[selectedCategory].find((p) => p.id === productId))
    .filter((p) => p !== undefined);

  return (
    <div className={styles.selectImageStepPreview}>
      <div className={styles.selectImageStepPreviewContent}>
        {products.map((product) => (
          <div key={product.id} className={styles.selectImageStepPreviewContentItem}>
            <ProductCard buyButtonText="ADD TO CART" imageUrl={product.mockupImageUrl} name={product.name} />
          </div>
        ))}
      </div>
    </div>
  );
};
